import {getSetupWizardStepsList} from 'contents/SetupWizard/content/SetupWizardContentBusiness';
import {SetupWizardStep} from '../../constants/SetupWizardEnum';
import {ViewMode} from '../../constants/dataEnum';
import {isTouchProbeExpanded} from './instrumentBusiness';

export const TrayCheckingEnum = {
  CHECK_TRAY_CALIBRATION: 0,
  CHECK_TRAY_TYPE: 1,
};

export class TrayRequirementChecker {
  constructor(state, isTouchProbeInitiallyExtended) {
    const {appState, wizardState, plateTypeEditorState} = state;
    const {viewMode} = appState;
    const {currentWizardView: plateTypeCreatorView} = plateTypeEditorState;

    this.isTouchProbeInitiallyExtended = isTouchProbeInitiallyExtended;
    this.viewMode = viewMode;
    this.setupWizardState = {};
    this.plateTypeCreatorView = plateTypeCreatorView;

    if (viewMode === ViewMode.SETUP_WIZARD) {
      this.setupWizardState = this.getSetupWizardTrayRequirement(wizardState);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  getSetupWizardTrayRequirement = (wizardState) => {
    const {currentWizardView, initialTrayType} = wizardState || {};
    const stepsList = getSetupWizardStepsList();

    const trayCalibrationStepNumber = stepsList.indexOf(SetupWizardStep.TRAY_CALIBRATION);
    const plateDefinitionStepNumber = stepsList.indexOf(SetupWizardStep.PLATE_DEFINITION);

    const hasPassedTrayCalibration = currentWizardView > trayCalibrationStepNumber;
    const isOnPlateDefinition = currentWizardView === plateDefinitionStepNumber;

    return {
      stepsList,
      currentStepNumber: currentWizardView,
      isOnPlateDefinition,
      hasPassedTrayCalibration,
      requiredTrayType: initialTrayType,
    };
  };

  isDoingPlateDefinition = () =>
    (this.viewMode === ViewMode.SETUP_WIZARD && this.setupWizardState.isOnPlateDefinition) ||
    (this.viewMode === ViewMode.PLATE_TYPE_EDITOR && this.plateTypeCreatorView === 2);

  getRequestedTrayType = () => {
    if (this.viewMode === ViewMode.SETUP_WIZARD) {
      return this.setupWizardState.requiredTrayType;
    }

    // no preference
    return null;
  };

  getTrayCheckingList = () => {
    const trayCheckingList = [];

    if (
      this.viewMode === ViewMode.PLATE_TYPE_EDITOR ||
      (this.viewMode === ViewMode.SETUP_WIZARD && this.setupWizardState.hasPassedTrayCalibration)
    ) {
      trayCheckingList.push(TrayCheckingEnum.CHECK_TRAY_CALIBRATION);
    }

    if (this.viewMode === ViewMode.SETUP_WIZARD) {
      trayCheckingList.push(TrayCheckingEnum.CHECK_TRAY_TYPE);
    }

    return trayCheckingList;
  };
}

/**
 * create a permission checker object
 * @returns {TrayRequirementChecker}
 */
const createTrayRequirementChecker = () => async (dispatch, getState) => {
  const isTouchProbeExtended = await dispatch(isTouchProbeExpanded());

  return new TrayRequirementChecker(getState(), isTouchProbeExtended);
};

export default createTrayRequirementChecker;
